<script lang="ts" setup>
import SafeHtml from "~/components/utils/SafeHtml.vue";
</script>

<template>
  <notifications position="top right" classes="my-3">
    <template #body="props">
      <div :class="['py-3 px-1', 'custom-notifications', props.item.type]">
        <div class="row gx-0">
          <div class="col-2 d-flex align-items-center justify-content-center">
            <i
              v-if="props.item.type === 'success'"
              class="bi bi-check-circle-fill fs-4 success"
            />
            <i
              v-else-if="props.item.type === 'error'"
              class="bi bi-exclamation-circle-fill fs-4 error"
            />
            <i
              v-else-if="
                props.item.type === 'warning' || props.item.type === 'warn'
              "
              class="bi bi-exclamation-circle-fill fs-4 warning"
            />
          </div>
          <div
            class="col-8 d-flex flex-column text-white align-items-start justify-content-center gap-1"
          >
            <h6
              v-if="props.item.title"
              class="notification-title text-start fw-semibold m-0"
            >
              {{ props.item.title }}
            </h6>
            <safe-html
              v-if="props.item.text"
              class="notification-content text-start m-0"
              :html="props.item.text"
            />
          </div>
          <div class="col-2 d-flex align-items-center justify-content-end">
            <button class="close bg-transparent border-0" @click="props.close">
              <i class="bi bi-x-lg fs-5"></i>
            </button>
          </div>
        </div>
      </div>
    </template>
  </notifications>
</template>

<style lang="scss">
@use "@/assets/scss/bootstrap-helpers" as *;

.vue-notification-group {
  // display: hidden;
  min-width: 35%;
  width: 100%;
  background-color: transparent;

  .vue-notification-wrapper {
    box-shadow: 10px 1px 20px 15px #54545480;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin-top: 2px;
    margin-bottom: 5px;
  }
}

.custom-notifications {
  .notification-title {
    font-size: $font-size-base * 1;
    @include media-breakpoint-up(md) {
      font-size: $font-size-base * 1.1;
    }
  }

  .notification-content {
    font-size: $font-size-base * 0.775;
    @include media-breakpoint-up(md) {
      font-size: $font-size-base * 0.875;
    }
  }

  &.success {
    text-align: center;
    background-color: var(--bs-white);
    border-left: 6px solid var(--bs-green);

    .notification-title,
    .notification-content {
      color: var(--bs-green);
    }

    i.success {
      color: var(--bs-green);
    }

    .close {
      color: var(--bs-gray);

      &:hover {
        color: var(--bs-green);
      }
    }
  }

  &.error {
    text-align: center;
    background-color: var(--bs-white);
    border-left: 6px solid var(--bs-red);

    .notification-title,
    .notification-content {
      color: var(--bs-red);
    }

    i.error {
      color: var(--bs-red);
    }

    .close {
      color: var(--bs-gray);

      &:hover {
        color: var(--bs-red);
      }
    }
  }

  &.warning,
  &.warn {
    text-align: center;
    background-color: var(--bs-white);
    border-left: 6px solid var(--bs-orange);

    .notification-title {
      color: var(--bs-orange);
    }
    .notification-content {
      color: var(--bs-orange);
    }

    i.warning {
      color: var(--bs-orange);
    }

    .close {
      color: var(--bs-orange);

      &:hover {
        color: var(--bs-red);
      }
    }
  }
}

.vue-notification {
  display: none;
}
</style>
